﻿import * as React from 'react';
import { Translate } from '../../../../../../shared/LanguageService';
import history from '../../../../../../shared/history';
import BaseTab from './BaseTab';

type HomeTabProps = {
    label: string;
};

const HomeRoute = '/';

let routes = [HomeRoute];

function HomeTab({ label, ...props }: HomeTabProps) {
    function handleClick() {
        history.push(HomeRoute);
    }

    return <BaseTab {...props} onClick={handleClick} label={label} route={HomeRoute} />;
}

function TranslatedHomeTab(props) {
    const label = Translate('header/nav/home');
    return <HomeTab {...props} label={label} />;
}

TranslatedHomeTab.routes = routes;

export default TranslatedHomeTab;
